/**
 * Created by mh on 2017/5/24.
 */
import React from 'react';
import { inject, observer } from 'mobx-react';

import PrivateRoute from './PrivateRoute.jsx';
import NavigationLeftComponent from './NavigationLeft';
import DashboardComponent from './Dashboard';
import JobsComponent from './jobs/App';

@inject('auth') @observer
export default class App extends React.Component {
    componentDidMount = () => {
        console.log('AppPublic did mount');
    };
    render() {
        if (this.props.auth) {
            console.log('Authentication isLoggedIn', this.props.auth.isLoggedIn, this.props.auth.isLoggingIn);
        } else {
            console.log('Authentication not set yet.');
        }
        return (
            <div className="row">
                <NavigationLeftComponent />

                <main className="col-sm-9 ml-sm-auto col-md-10 pt-3" role="main">
                    <PrivateRoute exact path="/home" name="Dash" component={DashboardComponent} />
                    <PrivateRoute path="/home/jobs" component={JobsComponent} />
                </main>
            </div>
        );
    }
}
